import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-175" data-mp="2ln2hwezvnnsn">
      <div className="max-w-3xl mx-auto" data-id="element-176" data-mp="2lm0wphp5dkx7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177" data-mp="26yfsfkgjdfnp">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-slate-900" data-id="element-178" data-mp="1y043rnz8crxw">
            ¿Te suena conocido esto?
          </h2>
          <p className="text-lg text-slate-700 leading-relaxed bg-white p-6 rounded-2xl border border-earth/20 shadow-sm" data-id="element-179" data-mp="1o0d8vl6rcaxa">
            Domingo a las 10 de la noche. Mañana tenés clase de producción
            agropecuaria. Y todavía estás buscando cómo explicar la diferencia
            entre producción extensiva e intensiva sin que tus alumnos se
            duerman o no entiendan nada.
            <br data-id="element-180" data-mp="1z056eydewiwg" />
            <br data-id="element-181" data-mp="1yzn69qnmpkj9" />
            <span className="text-earth font-bold" data-id="element-182" data-mp="1yz3yh2rp0ciy">No es tu culpa.</span> Es que
            llevás años peleando con materiales desorganizados, contenidos
            técnicos densos y recursos pensados para otros contextos que después
            tenés que reescribir entero.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-183" data-mp="23s6qv7kqhfxk">
          <h3 className="text-xl font-bold text-slate-900 mb-8 text-center" data-id="element-184" data-mp="1p3abepgcl0mx">
            El costo de no tener el material correcto:
          </h3>

          <ul className="space-y-4" data-id="element-185" data-mp="30hnuzi42itx5">
            {['Noches en vela buscando cómo traducir conceptos agropecuarios técnicos a un lenguaje que tus alumnos puedan entender y conectar con la realidad del campo', 'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo, y llegaste al aula con lo primero que encontraste', 'Alumnos desconectados que sienten que la producción agropecuaria no tiene nada que ver con ellos ni con su territorio', 'Silencios incómodos cuando un alumno pregunta por qué se usa riego por goteo en lugar de aspersión en determinado cultivo y no tenés una respuesta clara a mano', 'Fines de semana perdidos armando planificaciones, actividades y evaluaciones desde cero una y otra vez'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-white p-4 rounded-xl border border-red-900/10 shadow-sm" data-id="element-186" data-mp="1jek4q06u8r3j" data-mpi={i}>
                <span className="text-red-500 mt-1" data-id="element-187" data-mp="j5cdowmgvxju">🔴</span>
                <span className="text-slate-700" data-id="element-188" data-mp="e6rduyb4nfvx">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-earth/20" data-id="element-189" data-mp="a67fxsiqc88q">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-190" data-mp="585uj0xtzwu3">
              Basta de regalar tu tiempo libre. Tu dedicación ya la tenés. Ahora
              te falta la herramienta.
            </p>
            <p className="text-xl mt-4 text-slate-900 font-medium" data-id="element-191" data-mp="3rnialk6wrbbu">
              Planificá todo tu año hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}